import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ErrorHandlingService } from './error-handling.service';
import { RouterHelperService } from './router-helper.service';
import { SettingsService } from './settings.service';
import { WebApiModel } from '../models/web-api.model';

@Injectable()
export class ProfileService {
  constructor(
    private http: HttpClient,
    private _errorHandlingService: ErrorHandlingService,
  ) {}

  getPerson(id: string): Observable<WebApiModel.Person> {
    let params: HttpParams = new HttpParams();
    params = params.append(RouterHelperService.urlParam.id, id);
    return this.http.get(SettingsService.api.personProfileUrl, { params }).pipe(
      map((response) => response as WebApiModel.Person), // revisit after angular 7 upgrade
      catchError((error) => this._errorHandlingService.catchThrowError(error)),
    );
  }

  getPlace(id: string): Observable<WebApiModel.Place> {
    let params: HttpParams = new HttpParams();
    params = params.append(RouterHelperService.urlParam.id, id);
    return this.http.get(SettingsService.api.placeProfileUrl, { params }).pipe(
      map((response) => response as WebApiModel.Place), // revisit after angular 7 upgrade
      catchError((error) => this._errorHandlingService.catchThrowError(error)),
    );
  }
}
